/**
 * ============================================================================
 * DIALOGS STORE - CACHE RETRIEVAL BY GAME
 * ============================================================================
 * 
 * Functions for retrieving cached dialogs filtered by game ID.
 * 
 * @module dialogs/cache/byGame
 */

import { dialogStore } from "../store";
import type { Dialog } from "../types";

// ============================================================================
// CACHE RETRIEVAL BY GAME
// ============================================================================

/**
 * Get cached dialogs for a specific game.
 * 
 * Note: This reads from local cache. Call fetchDialogs() first to populate the cache.
 * 
 * @param gameId - The game ID to filter by
 * @returns Array of cached dialogs for the game
 * 
 * @example
 * ```ts
 * const dialogs = getCachedDialogs(gameId);
 * ```
 */
export function getCachedDialogs(gameId: string): Dialog[] {
  const allDialogs = dialogStore.getData();
  return allDialogs.filter(dialog => dialog.game_id === gameId);
}
